module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#photostory",
      toString: function () {
        return this.url;
      }
    }